import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './Inscripciones.css';

const Inscripciones = () => {
  return (
    <div className="inscripciones-page">
                      {/* Agregar el Header */}
                      <Header 
                userRole={null}
                username={null} 
                handleLogout={() => {}} 
                setModalOpen={() => {}} 
                setRegisterModalOpen={() => {}} 
            />
      {/* Hero Section */}
      <section className="inscripciones-hero" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.7), url(/images/inscripciones/hero-bg.jpg)' }}>
        <div className="hero-content">
          <h1>Inscripción <span>Online</span> Segura y Fácil</h1>
          <p>Regístrate en nuestros eventos deportivos en pocos minutos</p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="section-header">
          <h2>Beneficios de nuestra inscripción online</h2>
          <p>Diseñada para una experiencia rápida y sin complicaciones</p>
        </div>
        
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src="/images/icons/easy-icon.png" alt="Fácil" />
            </div>
            <h3>Fácil y rápida</h3>
            <p>Sistema intuitivo que te permite registrarte en minutos</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src="/images/icons/secure-icon.png" alt="Seguro" />
            </div>
            <h3>100% Seguro</h3>
            <p>Tus datos personales y financieros están protegidos</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src="/images/icons/access-icon.png" alt="Accesible" />
            </div>
            <h3>Accesible</h3>
            <p>Desde cualquier dispositivo con conexión a Internet</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src="/images/icons/confirm-icon.png" alt="Confirmación" />
            </div>
            <h3>Confirmación inmediata</h3>
            <p>Recibe tu comprobante de inscripción al instante</p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="section-header">
          <h2>¿Cómo funciona nuestro proceso de inscripción?</h2>
          <p>Sigue estos simples pasos para registrarte en nuestros eventos</p>
        </div>
        
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Selecciona el evento</h3>
              <p>Elige entre nuestras competencias disponibles</p>
              <div className="step-image">
                <img src="/images/inscripciones/step1.jpg" alt="Selección de evento" />
              </div>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Completa tus datos</h3>
              <p>Formulario simple y rápido</p>
              <div className="step-image">
                <img src="/images/inscripciones/step2.jpg" alt="Formulario de inscripción" />
              </div>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Pago con QR</h3>
              <p>Sistema seguro y sin complicaciones</p>
              <div className="step-image">
                <img src="/images/inscripciones/step3.jpg" alt="Pago con QR" />
              </div>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Confirmación</h3>
              <p>Recibe tu comprobante al instante</p>
              <div className="step-image">
                <img src="/images/inscripciones/step4.jpg" alt="Confirmación de inscripción" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Preview Section */}
      <section className="form-preview-section">
        <div className="section-header">
          <h2>Formulario de Inscripción</h2>
          <p>Diseño intuitivo para una experiencia fluida</p>
        </div>
        
        <div className="form-preview-container">
          <img src="/images/inscripciones/form-preview.jpg" alt="Vista previa del formulario" className="form-preview-image" />
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="section-header">
          <h2>Participantes Satisfechos</h2>
          <p>Lo que dicen nuestros deportistas</p>
        </div>
        
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-content">
              "El sistema de inscripción más fácil que he usado. El pago con QR fue instantáneo."
            </div>
            <div className="testimonial-author">
              <img src="/images/testimonials/user1.jpg" alt="Carlos M." />
              <span>Carlos M.</span>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="testimonial-content">
              "Recibí mi confirmación al instante. Todo el proceso tomó menos de 5 minutos."
            </div>
            <div className="testimonial-author">
              <img src="/images/testimonials/user2.jpg" alt="Ana P." />
              <span>Ana P.</span>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="testimonial-content">
              "Inscribí a todo mi equipo sin problemas. El sistema es muy intuitivo."
            </div>
            <div className="testimonial-author">
              <img src="/images/testimonials/user3.jpg" alt="Diego R." />
              <span>Diego R.</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-card">
          <h2>¿Necesitas ayuda con tu inscripción?</h2>
          <p>Nuestro equipo está listo para asistirte</p>
          <Link to="/contacto" className="cta-button">Contáctanos</Link>
        </div>
      </section>
    </div>
  );
};

export default Inscripciones;